import React, { useEffect, useState } from 'react';
import { View, Text, SectionList, ActivityIndicator, StyleSheet, Image } from 'react-native';
import { get, mediaUrl } from '../../api/client';
import { BLUE, BG, CARD, TEXT, TEXT_SUB, TEXT_MUTED, DIVIDER } from '../../theme/colors';

const CAT_LABELS: Record<string, string> = {
  mat: 'MAT', drikke: 'DRIKKE', søtt: 'SØTT',
  snacks: 'SNACKS', annet: 'ANNET',
};
function catLabel(k: string) { return CAT_LABELS[k.toLowerCase()] ?? k.toUpperCase(); }

export default function KioskScreen({ route }: any) {
  const competitionId: number = route.params.competitionId;
  const [data, setData] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    get(`/competitions/${competitionId}/kiosk`)
      .then(res => setData(res))
      .catch(e => console.warn(e))
      .finally(() => setLoading(false));
  }, [competitionId]);

  if (loading) return <View style={s.center}><ActivityIndicator color={BLUE} /></View>;
  if (!data) return <View style={s.center}><Text style={{ color: '#888' }}>Ingen kioskdata.</Text></View>;
  if (!data.is_open || !data.kiosks?.length) {
    return <View style={[s.center, { backgroundColor: BG }]}><Text style={{ fontSize: 16, color: '#888' }}>Kiosken er stengt akkurat nå.</Text></View>;
  }

  const kioskMeta = data.kiosks[0];
  const catMap: Record<string, any[]> = {};
  data.kiosks.forEach((k: any) => {
    Object.keys(k.categories || {}).forEach(cat => {
      if (!catMap[cat]) catMap[cat] = [];
      (k.categories[cat] || []).forEach((it: any) => catMap[cat].push(it));
    });
  });
  const sections = Object.keys(catMap)
    .filter(cat => cat.toLowerCase() !== 'billetter')
    .map(cat => ({ title: catLabel(cat), data: catMap[cat] }));

  return (
    <SectionList
      style={s.bg}
      sections={sections}
      keyExtractor={item => String(item.id)}
      stickySectionHeadersEnabled
      ListHeaderComponent={() => (
        <View style={s.header}>
          <Text style={s.headerSub}>{kioskMeta?.name ?? 'Kiosk'} · {data.is_open ? 'åpen' : 'stengt'}</Text>
          <Text style={s.headerTitle}>Meny</Text>
        </View>
      )}
      renderSectionHeader={({ section }) => (
        <View style={s.sectionHeader}><Text style={s.sectionTitle}>{section.title}</Text></View>
      )}
      renderItem={({ item }) => {
        const imgUri = item.image_url ? mediaUrl(item.image_url) : null;
        return (
          <View style={s.row}>
            {imgUri ? (
              <Image source={{ uri: imgUri }} style={s.thumb} resizeMode="cover" />
            ) : (
              <View style={[s.thumb, s.thumbPlaceholder]} />
            )}
            <View style={s.rowContent}>
              <Text style={s.itemName}>{item.name}</Text>
              {item.is_dugnad
                ? <Text style={s.itemSub}>Frivillig pris</Text>
                : item.stock_count != null
                  ? <Text style={s.itemSub}>{item.stock_count} igjen</Text>
                  : null}
            </View>
            {!item.is_dugnad && item.price != null ? (
              <Text style={s.price}>{item.price.toFixed(0)},-</Text>
            ) : null}
          </View>
        );
      }}
      ListFooterComponent={() => <View style={{ height: 24 }} />}
    />
  );
}

const s = StyleSheet.create({
  bg:     { flex: 1, backgroundColor: BG },
  center: { flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: BG },
  header: { paddingHorizontal: 16, paddingTop: 20, paddingBottom: 14, backgroundColor: BG },
  headerSub:   { fontSize: 13, color: TEXT_MUTED },
  headerTitle: { fontSize: 26, fontWeight: '700', color: TEXT, marginTop: 2 },
  sectionHeader: { backgroundColor: BG, paddingHorizontal: 16, paddingTop: 14, paddingBottom: 4 },
  sectionTitle:  { fontSize: 11, fontWeight: '700', color: TEXT_MUTED, letterSpacing: 1 },
  row: {
    flexDirection: 'row', alignItems: 'center',
    paddingHorizontal: 16, paddingVertical: 10,
    backgroundColor: CARD,
    borderBottomWidth: StyleSheet.hairlineWidth, borderColor: DIVIDER,
  },
  thumb: { width: 52, height: 52, borderRadius: 6, marginRight: 12 },
  thumbPlaceholder: { backgroundColor: '#EEF2F6' },
  rowContent: { flex: 1, marginRight: 8 },
  itemName:  { fontSize: 15, color: TEXT, fontWeight: '500' },
  itemSub:   { fontSize: 12, color: TEXT_MUTED, marginTop: 2 },
  price:     { fontSize: 15, color: TEXT, fontWeight: '600' },
  vippsBar: {
    margin: 16, padding: 14, backgroundColor: CARD, borderRadius: 10,
    alignItems: 'center', elevation: 1,
    shadowColor: '#000', shadowOpacity: 0.05, shadowRadius: 4, shadowOffset: { width: 0, height: 2 },
  },
  vippsText: { fontSize: 14, color: TEXT_SUB },
});
